import { Location } from './customTypes';

export const defaultLocation: Location = {
    'LIVE': {
        lat: 51.25,
        long: 10.5,
    },
};